import { ViewStateTypes } from '@common/enums/viewstate-types';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

import { SingleViewStateRecord } from './single-viewstate-record';

export class SearchViewStateRecord extends SingleViewStateRecord {
    public initialize() {
        this.viewStateType = ViewStateTypes.SEARCH;
        super.initialize();
    }

    public get viewStateSearchQuery(): string {
        return this.getAs<string>('PSTViewStateSearchQuery');
    }
    public set viewStateSearchQuery(value: string) {
        this.set('PSTViewStateSearchQuery', value);
    }

    recordTypes: ObjectTypes[] = null;
}
